import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  text: string
  onGoToFavorites?: () => void
  showBtn?: boolean
}

export const FavoritesToast = ({ text, onGoToFavorites }: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <span className={clsx('medium-14', s.text)}>{text}</span>

      {onGoToFavorites && (
        <div
          onClick={(e) => {
            e.stopPropagation()
            onGoToFavorites?.()
          }}
          className={clsx('medium-14', s.link)}
          role="button"
        >
          {t('favorites_block.go_to')}
        </div>
      )}
    </div>
  )
}
